import { Component, EventEmitter, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { GIFEmojiService } from '../../services/gif-emoji.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-gif-modal',
    templateUrl: './gif-modal.component.html',
    styleUrls: ['./gif-modal.component.css']
})
export class GifModalComponent implements OnInit {
    searchTerm: string = '';
    gifs: any;
    offset = 0;
    limit = 20; // Number of GIFs per request
    autoPlay: boolean = true; // By default, auto-play is off

    @Output() gifSelected: EventEmitter<any> = new EventEmitter();


    constructor(
        private gifEmojiService: GIFEmojiService,
        private cdr: ChangeDetectorRef,
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit(): void {
    }

    search(): void {
        if (this.searchTerm) {
            this.gifEmojiService.searchGifs(this.searchTerm, this.limit, 0).subscribe({
                next: (data) => {
                    this.gifs = data.results; // Assuming 'results' is the top-level key in the response
                    this.offset = data.next; // Assuming 'next' is the offset for the next set of results
                },
                error: (e) => console.error(e)
            });
        }
    }

    selectGif(gif: any): void {
        const gifData = {
            previewUrl: gif.media_formats.tinygifpreview.url,
            animatedUrl: gif.media_formats.tinygif.url
        };
        this.gifSelected.emit(gifData);  // Emitting an object with both URLs
        this.closeModal();
    }

    onScroll(event: any): void {
        const maxScroll = event.target.scrollHeight - event.target.clientHeight;
        const currentScroll = event.target.scrollTop;
        if (currentScroll === maxScroll) {
            this.loadMoreGifs();
        }
    }

    loadMoreGifs(): void {
        if (this.searchTerm && this.offset) {
            this.gifEmojiService.searchGifs(this.searchTerm, this.limit, this.offset).subscribe({
                next: (data) => {
                    this.gifs = this.gifs.concat(data.results); // Append new GIFs to the existing list
                    this.offset = data.next; // Update the offset
                },
                error: (e) => console.error(e)
            });
        }
    }

    toggleAutoplay(): void {
        //this.autoPlay = !this.autoPlay;
        //this.cdr.detectChanges();  // Force change detection to update the view
        if (this.searchTerm) {
            this.search();  // Re-execute search to refresh GIFs with the current auto-play setting
        }
    }

    clearSearch(): void {
        this.searchTerm = '';
        this.gifs = []; // Clear existing GIFs
        // Optionally call search if you want to reload or refresh the GIFs to a default state
    }

    closeModal() {
        this.activeModal.dismiss('Cross click');
    }


}
